import React from "react";
import { useLocation } from "react-router-dom";
import goldImg from "../Assets/Gold/Gold.png";
import hospitalityImg from "../Assets/Hospitality/Resort.png";
import agroImg from "../Assets/agrotech/Agrotech.png";
import propertyImg from "../Assets/properties/propertyban.png";
// import defaultImg from "../Assets/default-bg.jpg";
import "./ComingSoon.css";

export default function ComingSoon() {
  const location = useLocation();

  const bgImages = {
    "/Goldandiamonds": goldImg,
    "/Hospitality": hospitalityImg,
    "/Agrotech": agroImg,
    "/Properties": propertyImg,
  };

  const backgroundImage = bgImages[location.pathname];

  return (
    <div
      className="coming-soon-wrapper"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="overlay"></div>
      <div className="coming-soon-content">
        <h1>Coming Soon</h1>
        <p>We’re working hard to launch our Divisions. Stay tuned!</p>
      </div>
    </div>
  );
}
